import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: `共済契約者番号`,
    keyword: "mutualAidContractNumber",
    type: "label",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: `共済契約者名`,
    keyword: "mutualAidPolicyholderName",
    type: "label",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: `本部所在地郵便番号`,
    keyword: "zipcode",
    type: "addressSearch",
    requiredIcon: true,
    disabled: true,
    hideButton: true,
  },
  {
    title: `本部所在地`,
    disabled: true,
    keyword: "address",
    type: "locationGroup",
    requiredIcon: true,
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
  },
  {
    title: `担当者氏名`,
    keyword: "personInChargeName",
    type: "name",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: `本システムで使用するメールアドレス`,
    keyword: "emailAddressUsedInThisSystem",
    type: "label",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: `本システムで使用するメールアドレス（確認用）`,
    keyword: "emailAddressUsedInThisSystemForConfirmation",
    type: "label",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: `連絡先電話番号`,
    keyword: "contactPhoneNumber",
    type: "phoneNum",
    requiredIcon: true,
    disabled: true,
  },
  {
    title: `連絡先FAX番号`,
    keyword: "contactFAX",
    type: "phoneNum",
    disabled: true,
  },
  {
    title: `その他連絡事項`,
    keyword: "others",
    type: "textarea",
    disabled: true,
  },
];

export { fakeTableList };
